/**
 * API v1 for FLEXI web portal
 * A sample description of FLEXI API version 1 for web portal.
 *
 * OpenAPI spec version: 1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type Country = 'Undefined' | 'CZ' | 'SK' | 'EN';

export const Country = {
    Undefined: 'Undefined' as Country,
    CZ: 'CZ' as Country,
    SK: 'SK' as Country,
    EN: 'EN' as Country
};